import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const presentationHistorySuccess = (
  payload = {},
  type = types.FETCH_PRESENTATION_HISTORY_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const presentationHistoryLoading = (
  payload = {},
  type = types.LOADING_PRESENTATION_HISTORY
) => {
  return {
    type,
    payload
  };
};
